// extracted by mini-css-extract-plugin
export default {"SecondaryHeaderMain":"secondaryHeader_SecondaryHeaderMain__o2jIQ","editButton":"secondaryHeader_editButton__0lVt6"};